const SDK_VERSION = '7.53.1';

export { SDK_VERSION };
